import Hero from './components/Hero';
import FeaturedContent from './components/FeaturedContent';
import CategorySection from './components/CategorySection';
import LatestArticles from './components/LatestArticles';
import FAQ from './components/FAQ';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '樱桃视频',
  url: 'https://cherryvideo.com/',
  description: '在樱桃视频专题站了解热门内容、最新消息、观看方法与常见问题，发现更多值得关注的视频资讯。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://cherryvideo.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '樱桃视频',
  url: 'https://cherryvideo.com/',
  description: '专注于视频内容精选与资讯服务的综合性平台',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@cherryvideo.com',
    contactType: 'customer service',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '樱桃视频是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '樱桃视频是一个专注于精选视频内容与资讯的综合平台。我们为视频爱好者提供热门内容推荐、最新行业资讯、观看指南以及实用技巧分享。',
      },
    },
    {
      '@type': 'Question',
      name: '樱桃视频是免费的吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的，樱桃视频的所有内容和资讯均为免费提供。',
      },
    },
    {
      '@type': 'Question',
      name: '如何找到我感兴趣的视频内容？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '你可以通过首页搜索框、分类导航、"热门推荐"板块或"最新资讯"栏目找到感兴趣的内容。',
      },
    },
    {
      '@type': 'Question',
      name: '樱桃视频的内容多久更新一次？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '编辑团队每天更新内容，热门推荐每日更新，深度评测每周发布3-5篇，行业报告按月或季度发布。',
      },
    },
    {
      '@type': 'Question',
      name: '如何联系樱桃视频的客服团队？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '可以通过"关于我们"页面的联系表单提交问题，客服团队24小时内回复。',
      },
    },
  ],
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: '首页',
      item: 'https://cherryvideo.com/',
    },
  ],
};

export default function HomePage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />

      <main>
        <Hero />
        <FeaturedContent />
        <CategorySection />
        <LatestArticles />
        <FAQ />
      </main>
    </>
  );
}